module.exports = __webpack_public_path__ + "static/media/flight.e13012ac.svg";